module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [(_vm.dataRequiredLoaded) ? _c('div', {
    ref: "primeiraDiv",
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [(_vm.isGgv) ? _c('titulo-secao', {
    staticClass: "bg-warning text-black"
  }, [_c('strong', [_vm._v("GGV")]), _c('br'), _vm._v("\n            Você está fazendo a vistoria para guarda deste veículo\n          ")]) : _c('titulo-secao', [_vm._v("GRV")])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', [_c('form', {
    staticClass: "bs-example form-horizontal form-grv",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar a GRV, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Atualizado com sucesso!")])]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('div', {
    staticClass: "col-sm-12 col-xs-12 m-b"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [(_vm.podeAlterarStatus) ? _c('btn-altera-status-grv', {
    staticClass: "pull-right m-t-none",
    staticStyle: {
      "margin-top": "-10px !important"
    },
    attrs: {
      "lista-status": _vm.listaStatusPossiveisParaAlteracao
    },
    on: {
      "statusAlterado": _vm.start
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "grv"
    }
  }, [_vm._v("GRV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numero),
      expression: "data.numero"
    }],
    ref: "numeroGrv",
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.data.numeracaoManual,
      "id": "grv",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.numero)
    },
    on: {
      "blur": _vm.verificaNumeroGrv,
      "keyup": function($event) {
        _vm.data.numero = _vm.data.numero.replace(/\D/g, '')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "numero", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ACL.check('inserir_numero_grv_manual', _vm.currentUser.id)) ? [_c('label', {
    staticClass: "i-checks m-t-xs",
    attrs: {
      "for": "numeracaoManual"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numeracaoManual),
      expression: "data.numeracaoManual"
    }],
    attrs: {
      "type": "checkbox",
      "id": "numeracaoManual",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.numeracaoManual) ? _vm._i(_vm.data.numeracaoManual, null) > -1 : (_vm.data.numeracaoManual)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.numeracaoManual,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "numeracaoManual", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "numeracaoManual", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "numeracaoManual", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "numeracaoManual"
    }
  }, [_vm._v("Inserir número da GRV manualmente")])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataApreensao"
    }
  }, [_vm._v("Data da apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extraModel.dataApreensao),
      expression: "extraModel.dataApreensao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "dataApreensao",
      "placeholder": "dd/mm/yyyy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.extraModel.dataApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.extraModel, "dataApreensao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "horaApreensao"
    }
  }, [_vm._v("Hora da apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extraModel.horaApreensao),
      expression: "extraModel.horaApreensao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "horaApreensao",
      "placeholder": "00:00",
      "type": "time"
    },
    domProps: {
      "value": (_vm.extraModel.horaApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.extraModel, "horaApreensao", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataRemocao"
    }
  }, [_vm._v("Data de remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extraModel.dataRemocao),
      expression: "extraModel.dataRemocao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "dataRemocao",
      "placeholder": "dd/mm/yyyy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.extraModel.dataRemocao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.extraModel, "dataRemocao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "horaRemocao"
    }
  }, [_vm._v("Hora de remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extraModel.horaRemocao),
      expression: "extraModel.horaRemocao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "horaRemocao",
      "placeholder": "00:00",
      "type": "time"
    },
    domProps: {
      "value": (_vm.extraModel.horaRemocao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.extraModel, "horaRemocao", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Pátio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.patio),
      expression: "data.patio"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "patio",
      "required": "",
      "disabled": !_vm.podeEditarCampoPatio
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "patio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.patios), function(patio) {
    return _c('option', {
      key: patio.id,
      domProps: {
        "value": patio.id
      }
    }, [_vm._v("\n                                " + _vm._s(patio.nome) + "\n                              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Contrato")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.contrato),
      expression: "data.contrato"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "contrato",
      "required": "",
      "disabled": _vm.isGgv
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "contrato", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.listCategoriasBem]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.contratos), function(contrato) {
    return _c('option', {
      key: contrato.id,
      domProps: {
        "value": contrato.id
      }
    }, [_vm._v(_vm._s(contrato.nome) + "\n                                  ")])
  })], 2)])])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "liberarJudicial"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.liberarPorDecisaoJudicial),
      expression: "data.liberarPorDecisaoJudicial"
    }],
    attrs: {
      "type": "checkbox",
      "id": "liberarJudicial",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.liberarPorDecisaoJudicial) ? _vm._i(_vm.data.liberarPorDecisaoJudicial, null) > -1 : (_vm.data.liberarPorDecisaoJudicial)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.liberarPorDecisaoJudicial,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "liberarPorDecisaoJudicial", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "liberarPorDecisaoJudicial", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "liberarPorDecisaoJudicial", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "liberarJudicial"
    }
  }, [_vm._v("Liberar para Retirada por Decisão Judicial")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "liberarPrensa"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.liberarPorPrensa),
      expression: "data.liberarPorPrensa"
    }],
    attrs: {
      "type": "checkbox",
      "id": "liberarPrensa",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.liberarPorPrensa) ? _vm._i(_vm.data.liberarPorPrensa, null) > -1 : (_vm.data.liberarPorPrensa)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.liberarPorPrensa,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "liberarPorPrensa", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "liberarPorPrensa", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "liberarPorPrensa", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "liberarPrensa"
    }
  }, [_vm._v("Liberar para Retirada por Prensa")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "liberarRoubo"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.liberarPorRouboFurto),
      expression: "data.liberarPorRouboFurto"
    }],
    attrs: {
      "type": "checkbox",
      "id": "liberarRoubo",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.liberarPorRouboFurto) ? _vm._i(_vm.data.liberarPorRouboFurto, null) > -1 : (_vm.data.liberarPorRouboFurto)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.liberarPorRouboFurto,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "liberarPorRouboFurto", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "liberarPorRouboFurto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "liberarPorRouboFurto", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "liberarRoubo"
    }
  }, [_vm._v("Liberar para Retirada por Roubo/Furto")])])])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Local de Apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "enderecoApreensao"
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.enderecoApreensao),
      expression: "data.enderecoApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "enderecoApreensao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.enderecoApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "enderecoApreensao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "bairroApreensao"
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bairroApreensao),
      expression: "data.bairroApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "bairroApreensao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.bairroApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bairroApreensao", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "complementoApreensao"
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.complementoApreensao),
      expression: "data.complementoApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "complementoApreensao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.complementoApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "complementoApreensao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "ufApreensao"
    }
  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ufApreensao),
      expression: "data.ufApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ufApreensao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.ufApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "ufApreensao", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "cidadeApreensao"
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cidadeApreensao),
      expression: "data.cidadeApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "cidadeApreensao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.cidadeApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cidadeApreensao", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Dados do Veículo")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "sucata"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.sucata),
      expression: "data.sucata"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sucata",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.sucata) ? _vm._i(_vm.data.sucata, null) > -1 : (_vm.data.sucata)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.sucata,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "sucata", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "sucata", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "sucata", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sucata"
    }
  }, [_vm._v("Sucata")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "placa"
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.placa),
      expression: "data.placa"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "placa",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.placa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "placa", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm m-l-xs btn-colsultaGrv",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.consultaPlacaChassi
    }
  }, [_vm._v("Consultar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "chassi"
    }
  }, [_vm._v("Chassi")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.chassi),
      expression: "data.chassi"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "chassi",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.chassi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "chassi", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm m-l-xs btn-colsultaGrv",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.consultaPlacaChassi
    }
  }, [_vm._v("Consultar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "numeroMotor"
    }
  }, [_vm._v("Número do motor")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numeroMotor),
      expression: "data.numeroMotor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "numeroMotor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.numeroMotor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "numeroMotor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "estadoGeral"
    }
  }, [_vm._v("Estado geral")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.estadoGeral),
      expression: "data.estadoGeral"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "estadoGeral"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "estadoGeral", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Conservado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Regular")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Mal conservado")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "categoria"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bemCategoria),
      expression: "data.bemCategoria"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "categoria",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "bemCategoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.atualizaEquipamentoCategoria]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.categoriaBem), function(categoriaBem) {
    return _c('option', {
      key: categoriaBem.id,
      domProps: {
        "value": categoriaBem.id
      }
    }, [_vm._v("\n                                    " + _vm._s(categoriaBem.nome) + "\n                                  ")])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "marca"
    }
  }, [_vm._v("Marca/Modelo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.marca),
      expression: "data.marca"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "marca",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.marca)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "marca", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "modelo"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.modelo),
      expression: "data.modelo"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "modelo",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.modelo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "modelo", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "cor"
    }
  }, [_vm._v("Cor")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cor),
      expression: "data.cor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.cor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "vaga"
    }
  }, [_vm._v("Vaga")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.vaga),
      expression: "data.vaga"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "vaga",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.vaga)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "vaga", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "ano"
    }
  }, [_vm._v("Ano")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ano),
      expression: "data.ano"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ano",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.ano)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "ano", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "chavesVeiculo"
    }
  }, [_vm._v("Chave do veículo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.chavesVeiculo),
      expression: "data.chavesVeiculo"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "chavesVeiculo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "chavesVeiculo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Condutor")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Depósito")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "numeroChave"
    }
  }, [_vm._v("Número da chave")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numeroChave),
      expression: "data.numeroChave"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "numeroChave",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.numeroChave)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "numeroChave", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "renavam"
    }
  }, [_vm._v("Renavam")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.renavam),
      expression: "data.renavam"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "renavam",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.renavam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "renavam", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Dados do Reboque")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "reboquista"
    }
  }, [_vm._v("Empresa de Reboque")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empresaSelecionada),
      expression: "empresaSelecionada"
    }],
    staticClass: "form-control w-auto w-full-xs",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.empresaSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.carregaReboqueReboquista]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("selecione")]), _vm._v(" "), _vm._l((_vm.empresas), function(empresa) {
    return _c('option', {
      domProps: {
        "value": empresa.id
      }
    }, [_vm._v("\n                              " + _vm._s(empresa.nome) + " (" + _vm._s(_vm._f("formataCnpj")(empresa.cnpj)) + ")\n                            ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "reboquista"
    }
  }, [_vm._v("Reboquista")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.reboquista),
      expression: "data.reboquista"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "reboquista",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "reboquista", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.reboquistas), function(reboquista) {
    return _c('option', {
      key: reboquista.id,
      attrs: {
        "disabled": !reboquista.ativo
      },
      domProps: {
        "value": reboquista.id
      }
    }, [_vm._v("\n                            " + _vm._s(reboquista.nome) + " (#" + _vm._s(reboquista.codigo) + ") "), (!reboquista.ativo) ? _c('span', {
      staticStyle: {
        "font-size": "small",
        "color": "red"
      }
    }, [_vm._v("(inativo)")]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "reboque"
    }
  }, [_vm._v("Reboque")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.reboque),
      expression: "data.reboque"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "reboque",
      "required": "",
      "disabled": !_vm.empresaSelecionada
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "reboque", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.reboques), function(reboque) {
    return _c('option', {
      key: reboque.id,
      attrs: {
        "disabled": !reboque.ativo || reboque.deleted
      },
      domProps: {
        "value": reboque.id
      }
    }, [_vm._v("\n                            " + _vm._s(reboque.placa) + " "), (!reboque.ativo) ? _c('span', {
      staticStyle: {
        "font-size": "small",
        "color": "red"
      }
    }, [_vm._v("(inativo)")]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "kmForaCidade"
    }
  }, [_vm._v("KM fora cidade")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.kmForaDaCidade),
      expression: "data.kmForaDaCidade"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "kmForaCidade",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.kmForaDaCidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "kmForaDaCidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "kmInicial"
    }
  }, [_vm._v("KM inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.kmInicialDoReboque),
      expression: "data.kmInicialDoReboque"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "kmInicial",
      "type": "text",
      "required": _vm.tipoGrv === _vm.GRV_ESPIRITO_SANTO
    },
    domProps: {
      "value": (_vm.data.kmInicialDoReboque)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "kmInicialDoReboque", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_vm._v("KM inicial do reboque ao atender o acionamento.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "kmFinal"
    }
  }, [_vm._v("KM final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.kmFinalDoReboque),
      expression: "data.kmFinalDoReboque"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "kmFinal",
      "type": "text",
      "required": _vm.tipoGrv === _vm.GRV_ESPIRITO_SANTO
    },
    domProps: {
      "value": (_vm.data.kmFinalDoReboque)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "kmFinalDoReboque", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_vm._v("KM final do reboque ao atender o acionamento.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": "kmTotal"
    }
  }, [_vm._v("KM Total")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "kmTotal",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.kmTotal
    }
  })])])])])])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Identificação do Condutor")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "nomeCondutor"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nomeCondutor),
      expression: "data.nomeCondutor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "nomeCondutor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.nomeCondutor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nomeCondutor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "telefoneCondutor"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.telefoneCondutor),
      expression: "data.telefoneCondutor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "telefoneCondutor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.telefoneCondutor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "telefoneCondutor", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "cpfCondutor"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cpfCondutor),
      expression: "data.cpfCondutor"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cpfCondutor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.cpfCondutor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cpfCondutor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "rgCondutor"
    }
  }, [_vm._v("RG")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.rgCondutor),
      expression: "data.rgCondutor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rgCondutor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.rgCondutor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "rgCondutor", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "orgaoEmissorRgCondutor"
    }
  }, [_vm._v("Órgão Emissor")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.orgaoEmissorRgCondutor),
      expression: "data.orgaoEmissorRgCondutor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "orgaoEmissorRgCondutor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.orgaoEmissorRgCondutor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "orgaoEmissorRgCondutor", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "enderecoCondutor"
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.enderecoCondutor),
      expression: "data.enderecoCondutor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "enderecoCondutor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.enderecoCondutor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "enderecoCondutor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "estadoCondutor"
    }
  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.estadoCondutor),
      expression: "data.estadoCondutor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "estadoCondutor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.estadoCondutor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "estadoCondutor", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "cidadeCondutor"
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cidadeCondutor),
      expression: "data.cidadeCondutor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cidadeCondutor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.cidadeCondutor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cidadeCondutor", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Assinatura")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.condutorRecusouAssinar),
      expression: "data.condutorRecusouAssinar"
    }],
    attrs: {
      "type": "checkbox",
      "id": "recusouAssinar",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.condutorRecusouAssinar) ? _vm._i(_vm.data.condutorRecusouAssinar, null) > -1 : (_vm.data.condutorRecusouAssinar)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.condutorRecusouAssinar,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "condutorRecusouAssinar", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "condutorRecusouAssinar", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "condutorRecusouAssinar", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "recusouAssinar"
    }
  }, [_vm._v("Condutor se recusou a assinar")])])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Equipamentos / Acessórios")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.dataRequired.equipamentos), function(equip) {
    return _c('div', {
      key: equip.id,
      staticClass: "form-group b-b padder-v"
    }, [_c('div', {
      staticClass: "col-sm-offset-2 col-sm-10"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (equip.checked),
        expression: "equip.checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": equip.id,
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(equip.checked) ? _vm._i(equip.checked, null) > -1 : (equip.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = equip.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(equip, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(equip, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(equip, "checked", $$c)
          }
        }, function($event) {
          return _vm.marcaEquipamento($event, equip)
        }]
      }
    }), _c('i')]), _vm._v(" "), _c('label', {
      attrs: {
        "for": equip.id
      }
    }, [_vm._v(_vm._s(equip.nome))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('btn-check-possui', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (equip.checked),
        expression: "equip.checked"
      }],
      model: {
        value: (equip.possui),
        callback: function($$v) {
          _vm.$set(equip, "possui", $$v)
        },
        expression: "equip.possui"
      }
    })], 1)])])])
  }), 0)]), _vm._v(" "), _c('titulo-secao', [_vm._v("Agente Apreensor")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "nomeAgenteApreensor"
    }
  }, [_vm._v("Nome do agente")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nomeAgenteApreensor),
      expression: "data.nomeAgenteApreensor"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "nomeAgenteApreensor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.nomeAgenteApreensor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nomeAgenteApreensor", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "matriculaAgenteApreensor"
    }
  }, [_vm._v("Matrícula do agente")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.matriculaAgenteApreensor),
      expression: "data.matriculaAgenteApreensor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "matriculaAgenteApreensor",
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.matriculaAgenteApreensor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "matriculaAgenteApreensor", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "orgaoApreensor"
    }
  }, [_vm._v("Órgão apreensor")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.orgaoApreensor),
      expression: "data.orgaoApreensor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "orgaoApreensor",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "orgaoApreensor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.orgaoApreensor), function(orgao) {
    return _c('option', {
      key: orgao.id,
      domProps: {
        "value": orgao.id
      }
    }, [_vm._v("\n                            " + _vm._s(orgao.nome) + "\n                          ")])
  })], 2)])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Outras Informações")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "numeroAutoInfracao"
    }
  }, [_vm._v("Nº auto de infração")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numeroAutoInfracao),
      expression: "data.numeroAutoInfracao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "numeroAutoInfracao",
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.numeroAutoInfracao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "numeroAutoInfracao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "codigoInfracao"
    }
  }, [_vm._v("Motivo da Apreensão (código da infração)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.codigoInfracao),
      expression: "data.codigoInfracao"
    }],
    ref: "codigoInfracao",
    staticClass: "form-control",
    attrs: {
      "id": "codigoInfracao",
      "required": "",
      "type": "text",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.data.codigoInfracao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "codigoInfracao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "motivoInfracaoOutros"
    }
  }, [_vm._v("Motivo outros")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.motivoInfracaoOutros),
      expression: "data.motivoInfracaoOutros"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "motivoInfracaoOutros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.motivoInfracaoOutros)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "motivoInfracaoOutros", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "tipoRemocao"
    }
  }, [_vm._v("Tipo de remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tipoRemocao),
      expression: "data.tipoRemocao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tipoRemocao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "tipoRemocao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Conduzido")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Rebocado")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "tipoOperacao"
    }
  }, [_vm._v("Tipo operação")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tipoOperacao),
      expression: "data.tipoOperacao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tipoOperacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "tipoOperacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Remoção")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Apreensão")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "volumesInteriorVeiculo"
    }
  }, [_vm._v("Volumes ou acessórios no\n                        interior do\n                        veículo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.volumesInteriorVeiculo),
      expression: "data.volumesInteriorVeiculo"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "volumesInteriorVeiculo",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.volumesInteriorVeiculo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "volumesInteriorVeiculo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.comRubrica),
      expression: "data.comRubrica"
    }],
    attrs: {
      "type": "checkbox",
      "id": "comRubrica",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.comRubrica) ? _vm._i(_vm.data.comRubrica, null) > -1 : (_vm.data.comRubrica)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.comRubrica,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "comRubrica", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "comRubrica", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "comRubrica", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "comRubrica"
    }
  }, [_vm._v("Com Rúbrica")])])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Observações")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "observacoes"
    }
  }, [_vm._v("Observações")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.observacoes),
      expression: "data.observacoes"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "observacoes",
      "rows": "7"
    },
    domProps: {
      "value": (_vm.data.observacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "observacoes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.comAssinaturaCondutor),
      expression: "data.comAssinaturaCondutor"
    }],
    attrs: {
      "type": "checkbox",
      "id": "comAssinaturaCondutor",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.comAssinaturaCondutor) ? _vm._i(_vm.data.comAssinaturaCondutor, null) > -1 : (_vm.data.comAssinaturaCondutor)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.comAssinaturaCondutor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "comAssinaturaCondutor", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "comAssinaturaCondutor", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "comAssinaturaCondutor", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "comAssinaturaCondutor"
    }
  }, [_vm._v("Com assinatura do condutor")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.comAssinaturaTestemunha),
      expression: "data.comAssinaturaTestemunha"
    }],
    attrs: {
      "type": "checkbox",
      "id": "comAssinaturaTestemunha",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.comAssinaturaTestemunha) ? _vm._i(_vm.data.comAssinaturaTestemunha, null) > -1 : (_vm.data.comAssinaturaTestemunha)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.comAssinaturaTestemunha,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "comAssinaturaTestemunha", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "comAssinaturaTestemunha", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "comAssinaturaTestemunha", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "comAssinaturaTestemunha"
    }
  }, [_vm._v("Com assinatura da testemunha")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.condutorPresente),
      expression: "data.condutorPresente"
    }],
    attrs: {
      "type": "checkbox",
      "id": "condutorPresente",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.condutorPresente) ? _vm._i(_vm.data.condutorPresente, null) > -1 : (_vm.data.condutorPresente)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.condutorPresente,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "condutorPresente", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "condutorPresente", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "condutorPresente", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "condutorPresente"
    }
  }, [_vm._v("Condutor presente")])])])])]), _vm._v(" "), (_vm.isGgv) ? _c('titulo-secao', [_vm._v("Parecer Final")]) : _vm._e(), _vm._v(" "), (_vm.isGgv) ? _c('div', {
    staticClass: "wrapper-md m-b-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Em conformidade com a GRV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ggv.conforme),
      expression: "ggv.conforme"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ggv, "conforme", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Conforme")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não conforme")])])])])]) : _vm._e(), _vm._v(" "), _c('titulo-secao', [_vm._v("Lacres")]), _vm._v(" "), _c('lacres-grv', {
    attrs: {
      "lacres": _vm.data.lacres
    }
  }), _vm._v(" "), _c('titulo-secao', [_vm._v("\n                  Arquivos para GRVs "), (_vm.isFromSolicitacao) ? _c('small', [_vm._v("(As fotos da solicitação de remoção serão utilizadas automaticamente)")]) : _vm._e()]), _vm._v(" "), _c('arquivos-grv', {
    attrs: {
      "arquivos": _vm.data.arquivos,
      "tipos-arquivo": _vm.dataRequired.tipoArquivo,
      "permite-enviar-para-ggv": _vm.possuiACL('transferir_foto_grv_ggv') && !!(_vm.data.ggv && _vm.data.ggv.id)
    }
  }), _vm._v(" "), (!_vm.isGgv) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-success btn-md m-l-xs btn-colsultaGrv"
  }, [_vm._v("Salvar")])])])]) : _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block btn-lg"
  }, [_vm._v("Confirmar GGV")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                        * a confirmação inclui imeditamente este bem no pátio e transmite as informações para o DETRO\n                      ")])])])])], 1)])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b809c86","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/Grv.vue
// module id = 1977
// module chunks = 18